document.addEventListener('DOMContentLoaded', () => {

    // When datepicker is added to the DOM
    let myAccountForm = document.querySelector('.woocommerce .shop_table.subscription_details');

    if (myAccountForm !== null) {
        const config = {childList: true, subtree: true};
        const observer = new MutationObserver(function (mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function (item) {
                        if (item.id === 'wpr-pause-date-subscription') {
                            // Check if the datepicker has already been initialized
                            if (jQuery('#ssd-datepicker', item).data('datepicker')) {
                                // Datepicker is initialized, add the 'beforeShow' option
                                jQuery('#ssd-datepicker', item).datepicker('option', 'beforeShow', function (input, inst) {
                                    jQuery(input).datepicker('option', 'maxDate', '+31D');
                                });
                            } else {
                                // Wait until the datepicker is initialized
                                var initInterval = setInterval(function () {
                                    if (jQuery('#ssd-datepicker', item).data('datepicker')) {
                                        // Once initialized, clear the interval and set the option
                                        clearInterval(initInterval);
                                        jQuery('#ssd-datepicker', item).datepicker('option', 'beforeShow', function (input, inst) {
                                            jQuery(input).datepicker('option', 'maxDate', '+31D');
                                        });
                                    }
                                }, 100);
                            }
                        }
                    });
                }
            }
        });
        observer.observe(myAccountForm, config);
    }
});